<template>
    <l-layer-group
        :layer-type="overlay.type"
        v-model:visible="overlay_visible"
        :name="(overlay.name)"
        ref="unitsLayer"
        @ready="onReady()"
    >
        <l-feature-group
            ref="unitsCluster"
            id="units-cluster"
        ></l-feature-group>

        <l-feature-group
            ref="ETACluster"
            id="eta-cluster"
        ></l-feature-group>

    </l-layer-group>
    <!--  control  -->
    <template v-if="modelValue.visible && !routeMeta.isGuest">
        <l-control :position="openGeozoneEditControlPosition" v-if="(!isLimitedUser || isDealer) && $consts.app.$isIntuit && showGeozoneEdit">
            <button class="map-control" @click.stop="openGeozoneEdit">
                <SvgIcon class="icon" name="menu__geoitem_add"/>
            </button>
        </l-control>
        <l-control :position="'topright'" v-if="unitTracking">
            <button class="map-control" @click="openLocatorSettings">
                <SvgIcon class="icon" name="locator-icon"/>
            </button>
        </l-control>
        <l-control :position="'topright'" v-if="unitTracking && $isPrometheus">
            <button class="map-control" :class="[etaOptions && 'map-control--active']" @click="openETASearchAddress">
                <SvgIcon class="icon" name="eta-track"/>
            </button>
        </l-control>
    </template>

    <!-- openLocatorSettings popup -->
    <custom-modal v-if="modalWindows?.openLocatorSettings" v-bind="modalWindows?.openLocatorSettings?.props">
        <SectionLoading v-if="locatorTokenLoading"/>
        <div  v-else class="flex align-items-canter">
            <p class="flex-1 word-break-break-all">{{ locatorUrl }}</p>
            <button class="button button_command address-info__button" @click="copyLocatorUrl">
                <SvgIcon name="common__copy"/>
            </button>
        </div>
    </custom-modal>
    <!-- ETA popup -->
    <custom-modal v-if="modalWindows?.ETAAddress" v-bind="modalWindows?.ETAAddress?.props">
        <SectionLoading v-if="locatorTokenLoading"/>
        <addressSearch v-model="etaAddress"/>
    </custom-modal>
</template>
<script>
import {LControl, LFeatureGroup, LLayerGroup} from "@vue-leaflet/vue-leaflet";
import DriftMarker from "leaflet-drift-marker";
import {mapGetters, mapActions} from "vuex";
import {useToast} from "vue-toastification";
import debounce from "lodash/debounce";
import {copyTextToClipboard, diffObjects} from "@/lib/lib";
import {htmlToElement} from "@/lib/lib";
import {accessRight} from "@/lib/access-rights";
import addressSearch from "@/components/_base/addressSearch.vue";

export default {
    name: "SectionMap_layer_units",
    emits: ['update:modelValue'],
    mixins: [],
    inject: ['L', 'unitIcon', 'createMarker', 'mapLeafletObject', 'unitIconByType', 'mapBounds'],
    props: {
        modelValue: Object,
    },
    components: {
        addressSearch,
        LFeatureGroup,
        LLayerGroup,
        LControl,
    },
    data() {
        return {
            locatorTokenLoading: false,
            locatorUrl: '',
            modalWindows: {},
            toast: useToast(),
            openGeozoneEditControlPosition: 'topright',
            unitsLayer: null,
            unitsCluster: null,
            ETACluster: null,
            etaOptions: null,
            unitsMarkers: [],
            showGeozoneEdit: true,

            unitsLmsgsTimes: {},
            unitsClusterOptions: {
                chunkedLoading: true,
                removeOutsideVisibleBounds: true,
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                zoomToBoundsOnClick: true,
                disableClusteringAtZoom: 17,
                // iconCreateFunction: function(cluster) {
                //     return this.L.divIcon({ html: '<b>' + cluster.getChildCount() + '</b>' });
                // }
            },
        }
    },
    computed: {
        ...mapGetters([
            "getAppUserId",
            "getUnitsOnMap",
            "getUnitsByIds",
            "getUnitsLmsgsByIds",
            "getUnitsLmsgsLatlngByIds",
            "getUnitsMarkersOptionsByIds",
            "getUnitsHwTypesByType",

            "getMapPaddingBounds",
            "isDealer",
            "isLimitedUser"
        ]),
        overlay() {
            return this.modelValue
        },
        overlay_visible: {
            get() {
                return this.overlay?.visible
            },
            set(vl) {
                this.$emit('update:modelValue', {...this.overlay, visible: vl})
            },
        },
        isShowLayer() {
            return this.overlay?.showLayer
        },
        unitTracking() {
            let unitId = this.isShowLayer ? this.routeFilter.unitId : undefined
            let ok = !!this.getUnitsLmsgsByIds[unitId] && !!this.getUnitsByIds[unitId]
            return ok ? +unitId : undefined
        },
        activeUnit() {
            return this.getUnitsByIds[this.unitTracking]
        },
        isStationaryObj() {
            return !!this.getUnitsHwTypesByType[this.activeUnit?.hw_type]?.is_stationary_obj
        },
        fastGeozone() {
            return this.routeMeta.fastGeozone
        },
        isUnitAccessRight_edit() {
            let unitAccessRight = this.activeUnit?.access_right || 0
            return unitAccessRight >= accessRight.edit
        },
        unitsOnMap() {
            if (!this.isShowLayer) return []
            let unitsOnMap = [...this.getUnitsOnMap]
            if (this.unitTracking && !unitsOnMap.find(id => id == this.unitTracking)) unitsOnMap.push(this.unitTracking)
            return unitsOnMap//.filter(arrayFilter_OnlyUnique)
        },
        isUnitTracking() {
            return this.routeMeta.unitTracking && (!this.etaOptions)
        },
        updateUnitTrackingOnMap() {
            return [this.unitTracking, this.isUnitTracking].join('/')
        },
        unitsMarkersOptions(){
            return this.unitsOnMap.reduce((markersByIds, id) => {
                markersByIds[id] = this.getUnitsMarkersOptionsByIds[id]
                return markersByIds
            }, {})
        },
        etaAddress: {
            get() {
                return this.etaOptions?.address
            },
            set(address) {
                let coordinates = address.coordinates;
                if(coordinates) {
                    this.setMapBounds([Object.values(coordinates)])
                    this.fetchETA(address)
                        .then(() => {
                        this.setETAMarker(address)
                    })
                }
                if(!this.etaOptions) this.etaOptions= {}
                this.etaOptions.address = {...address, valueField: address.name}
            }
        },
    },
    watch: {
        unitTracking: {
            handler: function () {
                this.etaOptions = null
                this.setETAMarker(null)
            }
        },
        getMapPaddingBounds: {
            handler: function (newVl) {
                //if(this.$isDevelopment) console.log('fitBounds getMapPaddingBounds', newVl, {...this.$consts.components.map.paddingBounds})
                this.switchUnitTracking(this.routeFilter.unitId, newVl)
            },
            deep: true
        },
        updateUnitTrackingOnMap: {
            handler: function (newUnitId, oldUnitId) {
                if (!oldUnitId) {
                    // if(this.$isDevelopment) console.log('unitTracking', newUnitId, oldUnitId)
                }
                // if (!newUnitId) return false;
                //this.setMapBoundsByUnits([newUnitId])//????
                //this.setMarkers(this.unitsOnMap)
                if(this.isUnitTracking) {
                    this.switchUnitTracking(this.unitTracking, this.getMapPaddingBounds)
                }
            },
            immediate: true,
            // deep: true
        },
        unitsOnMap: {
            handler: function (newUnits/*, oldUnits*/) {
                // if(this.$isDevelopment) console.log('SectionMap watch unitsOnMap', newUnits, oldUnits)
                this.setMarkers(newUnits)
            },
            deep: true,
            immediate: true,
        },
        unitsMarkersOptions: {
            handler: function (newUnitsMarkers, oldUnitsMarkers) {
                let diff = Object.keys(newUnitsMarkers)
                    .map(id => diffObjects(oldUnitsMarkers[id], newUnitsMarkers[id]))
                    .filter(o => o)
                if(this.$isDevelopment) console.log('SectionMap watch unitsMarkersOptions', diff)
                if(diff.length) {
                    this.debouncedUpdateMarkers();
                }
            },
            deep: true,
            // immediate: true,
        },
        fastGeozone: {
            handler: function (nVal) {
                if(nVal) {
                    if(this.mainParentRouteName == this.$consts.routerNames.units.main) {
                        let latlng = this.getUnitsLmsgsLatlngByIds[this.unitTracking]
                        if(!latlng) return;
                        let paddingBounds = this.getMapPaddingBounds // || this.$consts.components.map.paddingBounds
                        if(paddingBounds) {
                            this.map.fitBounds([latlng], paddingBounds)
                        } else {
                            this.mapLeafletObject.setView(latlng, 15)
                        }
                    }
                }
            }
        },
    },
    methods: {
        ...mapActions([
            "setMapBoundsByUnits",
            "setMapBounds",
        ]),
        modalClose(clearEta = false) {
            this.modalWindows = {}
            if(clearEta) {
                this.etaOptions = null
            }
        },
        fetchETA(address) {
            return new Promise((resolve, reject) => {
                let latlng_start = Object.values(this?.getUnitsLmsgsByIds[this.unitTracking]?.latlng || {})//legs.fromCoordinates
                latlng_start = Object.values(latlng_start);
                let latlng_end = (address).coordinates
                latlng_end = Object.values(latlng_end || {})
                if(!latlng_start?.length || !latlng_end?.length) {
                    console.error('No data')
                    reject(false)
                }
                this.$api.locations
                    .eta({latlng_start, latlng_end})
                    .then((response) => {
                        if(response.status <= 400 && !response.data.error && !response.data.errors) {
                            this.etaOptions.eta = response.data
                            resolve(true)
                        } else {
                            console.error(response.data)
                            reject(false)
                        }
                    })
                    .catch(error => {
                        console.error(error)
                        reject(false)
                    })
                    .finally(() => {
                        // this.clearInterval()
                        // this.interval = setTimeout(this.fetchETA, 10000)
                    })
            })
        },
        switchUnitTracking(newUnitId, paddingBounds) {
            let latlng = this.getUnitsLmsgsLatlngByIds[newUnitId]
            // if(this.$isDevelopment) console.log('switchUnitTracking', {...latlng})
            if (!latlng) return false;

            if(paddingBounds) {
                if(this.$isDevelopment) console.log('fitBounds switchUnitTracking', 'MapPaddingBounds', paddingBounds)
                this.mapLeafletObject.fitBounds([latlng], paddingBounds)
            } else {
                if(this.$isDevelopment) console.log('setView switchUnitTracking', {...latlng})
                this.mapLeafletObject.setView(latlng, 15)
            }
        },
        setMarkers(newUnits) {
            let removed = this.unitsMarkers.filter(m => {
                return m.meta && !newUnits.includes(m.meta.id)
            }).map(m => m.meta.id)
            if (removed.length) this.removeMarkers(removed);
            this.addMarkers(newUnits);
        },
        setETAMarker(address) {
            this.ETACluster.clearLayers();
            if(address?.coordinates) {
                let options = {
                    id: 'eta',
                    etaOptions: this.etaOptions
                }
                let latLng = {lat: address?.coordinates?.latitude, lng: address?.coordinates?.longitude}
                let marker = new DriftMarker(latLng, {icon: this.ETAIcon()})
                marker.meta = {...options}
                let timeItcon = '/img/icons.svg#'+'circle__clock-2';
                let content =
                    `<div style="max-width: 300px;">
                        <div>${address.name}</div>
                        <div class="flex align-items-canter flex-gap-10">
                            <svg class="svg-icon-unit-marker" xmlns="http://www.w3.org/2000/svg" style="width: 15px; height: 15px">
                                <use xlink:href="${timeItcon}"/>
                            </svg>
                            <span>${options?.etaOptions?.eta?.duration?.text}</span>
                        </div>
                    </div>`

                marker.bindPopup(content, {offset: this.L.point(0, 0)});
                this.ETACluster.addLayer(marker)
                marker.openPopup()
            }
        },
        addMarkers(unitIds) {
            let markers = []
            // let colors = []
            unitIds.forEach(id => {
                let options = this.getUnitsMarkersOptionsByIds[id]
                if (!options || !options.latlng) return false

                let marker = this.unitsMarkers.find(m => m?.meta?.id == id)
                if (!marker) {
                    marker =
                        //this.L.marker(options.latlng, { icon: icon })
                        new DriftMarker(options.latlng, {icon: this.unitIcon})
                    // L_movingMarker([options.latlng], 100, { icon: this.unitIcon, autostart: true})
                    // this.L.animatedMarker(options.latlng, { icon: this.unitIcon,
                    //     // distance: 500,  // meters
                    //     // interval: 1000, // milliseconds
                    // })
                    let icon = this._unitIcon(options) || this.unitIconByType(options);
                    marker.setIcon(icon);
                    if(!this.routeMeta.isGuest || this.routeMeta.markerOnClick) {
                        marker.on('click', this.markerOnClick)
                    }
                    console.log(marker)
                    marker.meta = {...options}
                    markers.push(marker)
                }
            })
            this.unitsMarkers.push(...markers)
            if (this.unitsCluster) {
                //this.unitsCluster.addLayers(markers)
                markers.forEach((marker) => {
                    this.unitsCluster.addLayer(marker)
                })
            }
        },
        ETAIcon() {
            let html = '';
            let img_src = '/img/icons.svg#eta';
            html = '<div class="unit-marker-svg-icon" style="width: 30px; height: 30px; border-radius: 100%; display: flex; justify-content: center; align-items: center; border: solid 3px var(--Selected-Element); background: var(--White-Color)">' +
                '<svg class="svg-icon-unit-marker" xmlns="http://www.w3.org/2000/svg" style="width: 20px; height: 20px">' +
                '<use xlink:href="' + img_src + '"/>' +
                '</svg>' +
                '</div>';

            html = htmlToElement(html);
            return this.L.divIcon({
                className: 'direction-enabled',
                iconSize: [30, 30],
                html,
            })
        },
        _unitIcon(params, hideName = false) {
            params = params || {}
            let html = '';
            let [styleIcon, styleName] = ['styleIcon', 'styleName']
                .map(s => Object.keys(params[s] || {})
                    .filter(k => params[s][k])
                    .map(k => k + ':' + params[s][k])
                    .join(';')
                );
            switch (params.hw_type) {
                case 'm2m': {
                    let connection_type = this.getUnitsLmsgsByIds[params?.id]?.sensors?.connection_type?.value
                    let badge = this.$consts.connectionTypesIcon[connection_type] || 'empty'
                    badge = badge ? '/img/icons.svg#'+badge : '';

                    html = '<div class="unit-marker ' + (params.icon_has_halo ? 'unit-marker-has-halo' : '') + (hideName ? 'unit-marker-label-hide' : '') +'">' +
                        '<div class="unit-marker-svg-icon ' + params.statusClass + '" style="' + styleIcon + '">' +
                        '<svg class="svg-icon-unit-marker" xmlns="http://www.w3.org/2000/svg">' +
                        '<use xlink:href="' + params.img_src + '"/>' +
                        '</svg>' +
                        '</div>' +
                        '<div class="leaflet-label unit-marker-label" style="' + styleName + '">' + params.name + '</div>' +
                        (badge ?
                            '<div class="unit-marker-badge">' +
                                '<svg class="svg-icon-unit-marker" xmlns="http://www.w3.org/2000/svg">' +
                                '<use xlink:href="' + badge + '"/>' +
                                '</svg>' +
                            '</div>' : '') +
                        '</div>';

                    html = htmlToElement(html);
                    html = this.L.divIcon({
                        className: 'direction-enabled' + (params.icon_has_halo ? ' has-halo' : ''),
                        iconSize: [32, 32],
                        html,
                    })
                }
            }
            return html;
        },
        updateMarkers() {
            // if(this.$isDevelopment) console.log('updateMarkers', this.unitTracking)
            let updated = 0
            let moved = 0
            this.unitsOnMap.forEach(id => {
                let options = this.unitsMarkersOptions[id]
                if (!options || !options.latlng) return false

                let marker = this.unitsMarkers.find(m => m?.meta?.id == id)
                if (!marker) {
                    return false
                }
                let diff = diffObjects(marker.meta, options) // || {}

                //if(['name','icon_has_halo','course','styleIcon','styleName','statusClass','img_src'].filter(fld => Object.keys(diff).includes(fld)))
                if (diff)
                {
                    if(this.$isDevelopment) console.log('updateMarkers', 'diffMarkerOptions', diff)
                    let icon = this._unitIcon(options) || this.unitIconByType(options);
                    marker.setIcon(icon);
                    updated++
                }
                if (diff?.time && marker?.meta?.time < options.time) { //  && (marker?.meta?.latLng.lat != options.latLng.lat || marker?.meta?.latLng.lon != options.latLng.lon)
                    let isMoveTo = (this.unitTracking === id && this.isUnitTracking)
                        // || (this.mapBounds && (this.mapBounds.contains(marker.getLatLng()) || this.mapBounds.contains(options.latlng)))
                    if (isMoveTo) {
                        let slideOptions = {
                            duration: 3000,
                            keepAtCenter: false,
                        }
                        if (this.unitTracking === id && !this.isStationaryObj && this.isUnitTracking) {
                            slideOptions.keepAtCenter = true
                        }
                        // if(slideOptions.keepAtCenter) //console.log('marker.slideTo', {...options.latlng}, {...slideOptions}, marker.slideTo)
                        marker.slideTo(options.latlng, slideOptions)//overloads style settings
                        if (slideOptions.keepAtCenter) {
                            marker._slideDraggingWasAllowed = true;//Hack
                        }
                        // if(slideOptions.keepAtCenter) //console.log('marker.slideTo', {...options.latlng}, {...slideOptions}, marker.slideTo)
                        // if (this.unitTracking === id && !this.isStationaryObj && this.isUnitTracking) {
                        //     this.mapLeafletObject.fitBounds([lmsg.latlng], this.getMapPaddingBounds)
                        // }
                        moved++
                    } else {
                        marker.setLatLng(options.latlng)//overloads style settings
                        moved++
                    }
                    //marker?.meta?.time = options.time
                }
                marker.meta = {...options}
            })
            if (this.unitsMarkers.length) {
                if(this.$isDevelopment) console.log('updateMarkers', this.unitsMarkers.length, 'moved=', moved, 'updated=', updated)
            }
        },
        removeMarkers(unitIds) {
            // if(this.$isDevelopment) console.log('removeMarkers', this.unitsMarkers.length)
            let markers = this.unitsMarkers.filter(m => {
                return m.meta && unitIds.includes(m.meta.id)
            })
            //this.unitsCluster.removeLayers(markers)
            markers.forEach((marker) => {
                this.unitsCluster.removeLayer(marker)
            })
            this.unitsMarkers = this.unitsMarkers.filter(m => {
                return m.meta && !unitIds.includes(m.meta.id)
            })
            // if(this.$isDevelopment) console.log('removeMarkers', this.unitsMarkers.length)
        },
        markerOnClick(event) {
            //if(this.$isDevelopment) console.log('markerOnClick', event)//target.meta.id
            this.setRoute.unitInfo(this.$route, this.$router, event.target.meta.id)
        },
        onReady() {
            if(this.$isDevelopment) console.log('ready')
            this.unitsCluster = // new MarkerClusterGroup(this.unitsClusterOptions);
                this.$refs.unitsCluster.leafletObject
            this.ETACluster = // new MarkerClusterGroup(this.unitsClusterOptions);
                this.$refs.ETACluster.leafletObject
            if (this.unitsMarkers) {
                // this.unitsCluster.addLayers(this.unitsMarkers)
                this.unitsMarkers.forEach((marker) => {
                    this.unitsCluster.addLayer(marker)
                })
            }
            this.unitsLayer = this.$refs.unitsLayer.leafletObject
        },
        openGeozoneEdit() {
            this.setRoute.fastGeoitem(this.$route, this.$router, this.unitTracking)
        },
        getLocatorUrl() {
            this.locatorUrl = ''
            this.locatorTokenLoading = true
            this.$api.locator.getToken({unit_id: this.unitTracking})//timeout: 12*3600
                .then((resp) => {
                    let data = resp.data
                    if (data?.error || !data?.token) {
                        this.toast.warning(this.$t('errors.Token error'))
                        console.error('token error', data)
                        this.locatorUrl = data.message || this.$t('errors.Token error');
                    } else {
                        let host = window.location.origin
                        this.locatorUrl = host + '/locator?token=' + data.token
                    }
                })
                .catch((error) => {
                    console.error(error)
                })
                .finally(() => {
                    this.locatorTokenLoading = false
                })
        },
        openLocatorSettings() {
            this.getLocatorUrl()
            this.modalWindows = {
                'openLocatorSettings': {
                    props:{
                        title: this.$t('map.Shared Locator Link'),
                        btnOkClass: 'button_theme_neutral',
                        modalClass: 'modal-300',
                        buttons:[
                            {id: 'ok', fn: () => this.modalClose()},
                            // {id: 'cancel', fn: () => this.modalClose()},
                        ]
                    }
                }
            }
        },
        showETATrack() {
            let latlngs = []
            let ETAlatLng = Object.values(this.etaOptions?.address?.coordinates || {})
            if(ETAlatLng.length) latlngs.push(ETAlatLng)

            let unitLatlng = Object.values(this?.getUnitsLmsgsByIds[this.unitTracking]?.latlng || {})
            if(unitLatlng.length) latlngs.push(unitLatlng)

            if(unitLatlng.length) {
                this.setMapBounds([ETAlatLng, unitLatlng])
            }
        },
        modalETAAddressOk() {
            this.showETATrack()
            this.modalClose()
        },
        openETASearchAddress() {
            if(this.etaOptions) {
                this.etaOptions = null
                return false;
            }
            this.etaOptions = {address: {valueField: ''}}
            this.modalWindows = {
                'ETAAddress': {
                    props:{
                        title: 'ETA',
                        btnOkClass: 'button_theme_neutral',
                        modalClass: 'modal-300 modal_hide_close-btn',
                        buttons:[
                            {id: 'ok', fn: () => this.modalETAAddressOk()},
                            {id: 'cancel', fn: () => this.modalClose(true)},
                        ]
                    }
                }
            }
        },
        copyLocatorUrl() {
            copyTextToClipboard(this.locatorUrl)
                .then(() => {
                    this.toast.success(this.$t('Copy done'));
                })
                .catch((er) => {
                    this.toast.warning(this.$t('errors.Copy error, please copy manually'));
                    console.error('copy error', er);
                })
        }
    },
    created() {
        this.debouncedUpdateMarkers = debounce(this.updateMarkers, 300)
    },
    mounted() {
    },
    updated() {
        if(this.$isDevelopment) console.log('updated', this._.type.name)
    },
    beforeUnmount() {
    }
}
</script>

<style scoped lang="scss">
.map-control--active {
    background: var(--Base-Dark-Blue-5) !important;
    .icon {
        color: var(--White-Color) !important;
    }
}
</style>